import {
  LOGIN_SUCCESS,
  CHANGE_LOGIN_LANGUAGE,
  LOGIN_KEYCLOAK,
  SET_ACCESS_TOKEN,
  SET_INFOS_MULTI_BUSINESS,
  SET_CURRENT_USER,
  SET_FIREWALL_BLOCKED,
  MFA_REQUIRED,
  MFA_CLEAR,
} from "./constants"
import { getLangageIdFromNavigator } from "Utils/global"

const getDefaultLoginLanguage = () => {
  try {
    return getLangageIdFromNavigator()
  } catch (error) {
    return 0
  }
}

const initialState = {
  userConnected: {},
  jwt: "",

  message: "",
  status: null,
  languageLogin: getDefaultLoginLanguage(),
  infosMultiBusiness: [],
  isMultiBusiness: false,
  firewallBlocked: null,
  mfaChallenge: null,
}

function loginReducer(state = initialState, { type, payload }) {
  switch (type) {
    case LOGIN_SUCCESS:
    case LOGIN_KEYCLOAK:
      return {
        ...state,
        jwt: payload.token,
        userConnected: payload.infos,
      }
    case SET_ACCESS_TOKEN:
      return {
        ...state,
        jwt: payload,
      }

    case CHANGE_LOGIN_LANGUAGE:
      return {
        ...state,
        languageLogin: payload,
      }
    case SET_INFOS_MULTI_BUSINESS:
      return {
        ...state,
        infosMultiBusiness: payload,
        isMultiBusiness: payload?.length > 0,
      }
    case SET_CURRENT_USER:
      return {
        ...state,
        userConnected: payload,
      }
    case SET_FIREWALL_BLOCKED:
      return {
        ...state,
        firewallBlocked: payload,
      }
    case MFA_REQUIRED:
      return {
        ...state,
        mfaChallenge: payload,
      }
    case MFA_CLEAR:
      return {
        ...state,
        mfaChallenge: null,
      }
    default:
      return state
  }
}

export default loginReducer
